import { Component, Input } from '@angular/core';

@Component({
  selector: 'password-rule',
  templateUrl: './password-rule.component.html',
  styleUrl: './password-rule.component.css'
})
export class PasswordRuleComponent {
  @Input() rule: string = '';
  @Input() isPass: boolean = false;
}
